export default __webpack_public_path__ + "static/media/add-plant-popup.067fef54.svg";